import * as React from 'react';
import { useControllableState } from '@fluentui/react-utilities';
const noop = ()=>undefined;
export const defaultTableSortState = {
    getSortDirection: ()=>'ascending',
    setColumnSort: noop,
    sort: (rows)=>[
            ...rows
        ],
    sortColumn: undefined,
    sortDirection: 'ascending',
    toggleColumnSort: noop
};
export function useTableSort(options) {
    // False positive, these plugin hooks are intended to be run on every render
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (tableState)=>useTableSortState(tableState, options);
}
export function useTableSortState(tableState, options) {
    const { columns } = tableState;
    const { sortState, defaultSortState, onSortChange } = options;
    const [sorted, setSorted] = useControllableState({
        initialState: {
            sortDirection: 'ascending',
            sortColumn: undefined
        },
        defaultState: defaultSortState,
        state: sortState
    });
    const { sortColumn, sortDirection } = sorted;
    const toggleColumnSort = (e, columnId)=>{
        setSorted((s)=>{
            var _onSortChange;
            const newState = {
                ...s,
                sortColumn: columnId
            };
            if (s.sortColumn === columnId) {
                newState.sortDirection = s.sortDirection === 'ascending' ? 'descending' : 'ascending';
            } else {
                newState.sortDirection = 'ascending';
            }
            (_onSortChange = onSortChange) === null || _onSortChange === void 0 ? void 0 : _onSortChange(e, newState);
            return newState;
        });
    };
    const setColumnSort = (e, nextSortColumn, nextSortDirection)=>{
        var _onSortChange;
        const newState = {
            sortColumn: nextSortColumn,
            sortDirection: nextSortDirection
        };
        (_onSortChange = onSortChange) === null || _onSortChange === void 0 ? void 0 : _onSortChange(e, newState);
        setSorted(newState);
    };
    const sort = (rows)=>{
        return rows.slice().sort((a, b)=>{
            var _sortColumnDef;
            const sortColumnDef = columns.find((column)=>column.columnId === sortColumn);
            if (!((_sortColumnDef = sortColumnDef) === null || _sortColumnDef === void 0 ? void 0 : _sortColumnDef.compare)) {
                return 0;
            }
            const mod = sortDirection === 'ascending' ? 1 : -1;
            return sortColumnDef.compare(a.item, b.item) * mod;
        });
    };
    const getSortDirection = (columnId)=>{
        return sortColumn === columnId ? sortDirection : undefined;
    };
    return {
        ...tableState,
        sort: {
            sort,
            sortColumn,
            sortDirection,
            setColumnSort,
            toggleColumnSort,
            getSortDirection
        }
    };
}
